const PlanningStatusEnum = {
  Created: 'Created',
  ClientConfirmed: 'ClientConfirmed',
  OnField: 'OnField',
  OnHold: 'OnHold',
  Closed: 'Closed',
  Cancelled: 'Cancelled',
  // Set only by the re-pricing automation, on the fieldwork periods of a price that a newer
  // approved price superseded. Never offered as a manual status change - display only.
  Replaced: 'Replaced',
};

export default PlanningStatusEnum;
